export enum LoadingState {
    Loading,
    Loaded,
    Errored
}